// extracted by mini-css-extract-plugin
module.exports = {"Burger":"Burger_Burger__ifXEl"};